<ng-template #swimlaneMainItemTmpl>
  <div layout-vertical>
    <div layout layout-space-between>
      <span>{{ 'app.views.view_settings.swimlanes' | translate }}</span>
      <rt-icon name="chevron-right" />
    </div>
    <span text-small text-weight-default text-color>
      {{
        !currentSwimlane?.id
          ? ('app.views.view_settings.hidden' | translate)
          : currentSwimlane!.name
      }}
    </span>
  </div>
</ng-template>

<ng-template #swimlanesTmpl>
  <rt-dropdown-header>
    <rt-icon-button
      prefix
      [iconName]="'arrow-back'"
      size="small"
      variant="plain"
      (click)="mainDropdown.prevTemplate()"
    />
    {{ 'app.views.view_settings.swimlanes' | translate }}
  </rt-dropdown-header>
  <div class="items">
    @for (swimlane of swimlanesWithNone(); track swimlane.id) {
      <rt-dropdown-item (click)="changeSwimlane(swimlane)">
        {{ swimlane.name }}
        @if ((layoutControl().value!.swimlane?.configId ?? null) === swimlane.id) {
          <rt-icon suffix name="check" colorToken="colorIconSuccessDefault" />
        }
      </rt-dropdown-item>
    }
  </div>
</ng-template>

<ng-template #swimlanesSettingsTmpl>
  <rt-dropdown-header>
    <rt-icon-button
      prefix
      [iconName]="'arrow-back'"
      size="small"
      variant="plain"
      (click)="mainDropdown.prevTemplate()"
    />
    {{ 'app.views.view_settings.swimlanes' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item [targetFor]="swimlanesTmpl">
    <rt-icon prefix name="swimlane" />
    <ng-template [ngTemplateOutlet]="swimlaneMainItemTmpl" />
  </rt-dropdown-item>
  <rt-dropdown-item
    [rtTooltip]="'app.views.view_settings.hide_empty_swimlanes_disabled_tooltip' | translate"
    [rtTooltipEnabled]="!currentSwimlane?.id"
    [rtTooltipPosition]="'left'"
    [class.disabled]="!currentSwimlane?.id"
    (click)="onHideEmptyClick()"
  >
    <rt-icon prefix name="visibility-off" />
    {{ 'app.views.view_settings.hide_empty_swimlanes' | translate }}
    <rt-toggle
      suffix
      [checked]="$safeNavigationMigration(layoutControl().value!.swimlane?.hideEmpty)!"
      (click)="onHideEmptyClick()"
    />
  </rt-dropdown-item>
</ng-template>

<rt-dropdown-item
  [targetFor]="swimlanesSettingsTmpl"
  (click)="viewsAnalytics.settingsSwimlanesOpen()"
>
  <rt-icon prefix name="swimlane" />
  <ng-template [ngTemplateOutlet]="swimlaneMainItemTmpl" />
</rt-dropdown-item>
